export default {"src":"/_next/static/media/overige-sport-en-spel.fdf44bd3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};